import type { RouteRecordRaw } from "vue-router";
import { APP_SETTINGS_AGREEMENTS_ROUTES as AGREEMENTS } from "@/Generated/Routes/paths";

const legalAgreementsRoutes: RouteRecordRaw[] = [
  {
    ...AGREEMENTS.root,
    meta: {
      i18nTitle: "settings.legal_agreements-title",
    },
    component: () => import("@/Views/settings/legal-agreements/LegalAgreements.vue"),
  },
  {
    ...AGREEMENTS.view.root,
    meta: {
      i18nTitle: "legal_agreement_view-title",
    },
    component: () => import("@/Views/settings/legal-agreements/LegalAgreementView.vue"),
  },
];

export default legalAgreementsRoutes;
